import { createColumnHelper } from "@tanstack/react-table";
import {
  EditActionButton,
  ViewActionButton,
  PrintActionButton,
} from "../../../../../../components/common/primebmd-ui/EditActionButton";
import { ESRColumns } from "../utils/types";
import { useAuth } from "../../../../../../components/AuthProvider";
import { useSnackBar } from "../../../../../../components/ToastProvider";
import moment from "moment";

export const useCreateESRCompletedColumns = () => {
  const { showSnackBar } = useSnackBar();
  const currUser = useAuth();
  const hasESRManagementPermission =
    currUser &&
    currUser?.currentUserRole?.permissions.includes("ESR::MANAGEMENT");

  const handlePrint = (id?: string) => {
    if (!id) return;
    showSnackBar("PDF Preview started", "success");
    const url = `${process.env.REACT_APP_API_URL}esr/pdf/${id}`;
    window.open(url, "_blank");
  };

  const columnHelper = createColumnHelper<ESRColumns>();

  const esrCompletedColumns = [
    columnHelper.accessor("esrNumber", {
      id: "esrNumber",
      header: "JO No.",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("equipmentNo", {
      id: "equipmentNo",
      header: "Equipment No.",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("projectLocation", {
      id: "projectLocation",
      header: "Project / Location",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("dateCompleted", {
      id: "dateCompleted",
      header: "Date Completed",
      cell: (row) => moment(row.getValue()).format('MM/DD/yyyy'),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    ...(hasESRManagementPermission
      ? [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => (
              <>
                <ViewActionButton route={`view/${row.original.id}`} />
                <PrintActionButton
                  onClick={() => handlePrint(row.original.id)}
                />
              </>
            ),

            enableHiding: false,
          }),
        ]
      : [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => (
              <>
                <ViewActionButton route={`view/${row.original.id}`} />
                <PrintActionButton
                  onClick={() => handlePrint(row.original.id)}
                />
              </>
            ),

            enableHiding: false,
          }),
        ]),
  ];

  return esrCompletedColumns;
};
